import { memo, useRef, useState } from 'react';
import { CheckIcon } from '@page/icons';

import { Button, ButtonProps } from '../../designSystem/Button';

interface CopyButtonProps extends ButtonProps {
  value?: string;
  icon?: React.ReactNode;
  text?: string;
  copiedText?: string;
  timeout?: number;
  onClick?: (event: React.MouseEvent) => void;
}

const CopyButtonBase = ({
  value,
  icon,
  text = 'Copy',
  copiedText = 'Copied',
  timeout = 2000,
  onClick,
  ...rest
}: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const timeoutRef = useRef<number | null>(null);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    setIsCopied(true);

    if (value) {
      navigator.clipboard.writeText(value);
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      setIsCopied(false);
    }, timeout);

    onClick?.(event);
  };

  return (
    <Button
      leftIcon={isCopied ? <CheckIcon className="size-5 fill-icon-success" /> : icon}
      size="lg"
      variant="outline"
      onClick={handleClick}
      {...rest}
    >
      {isCopied ? copiedText : text}
    </Button>
  );
};

export const CopyButton = memo(CopyButtonBase);
